import React from "react";
import PropTypes from "prop-types";
import {
  createMuiTheme,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  ThemeProvider,
} from "@material-ui/core";
import AuthorizationWrapper from "../AuthorizationWrapper";
import TextFieldDialog from "../Dialogs/TextFieldDialog";
import { makeStyles } from "@material-ui/core/styles";

const theme = createMuiTheme({
  palette: {
    error: {
      main: "#3f51b5",
    },
  },
});

const useStyles = makeStyles(() => ({
  formControl: {
    minWidth: 120,
  },
  selectMenu: { paddingTop: 6, fontSize: 12 },
}));

function EditSelect(props) {
  const classes = useStyles();
  const [beginValue, setBeginValue] = React.useState(props.value);
  const [value, setValue] = React.useState(props.value);

  const handleKeyDown = (e) => {
    e.nativeEvent.stopImmediatePropagation();
  };

  const getField = (write) => {
    return (
      <ThemeProvider theme={theme}>
        <FormControl variant={"outlined"} className={classes.formControl} size={"small"} fullWidth>
          {props.label && <InputLabel>{props.label}</InputLabel>}
          <Select
            label={props.label}
            inputProps={props.inputProps}
            classes={{ selectMenu: classes.selectMenu }}
            variant={"standard"}
            multiple={props.multiple}
            error={value !== beginValue}
            color={"primary"}
            onClick={(e) => {
              e.stopPropagation();
            }}
            onKeyDown={handleKeyDown}
            disabled={props.disabled != null ? props.disabled || !write : !write}
            onChange={(e) => {
              setValue(e.target.value);
              if (props.multiple) {
                if (!beginValue.equals(e.target.value)) {
                  props.onChange(e.target.value, setBeginValue);
                }
              } else {
                if (beginValue.toString() !== e.target.value) {
                  /// float compared to string
                  props.onChange(e.target.value, setBeginValue);
                }
              }
            }}
            value={value}
          >
            {props.optionValues.map((option, index) => (
              <MenuItem key={option} value={option}>
                {props.optionViewValues[index]}
              </MenuItem>
            ))}
            {props.allowUnknown ? (
              <MenuItem key={"+"} value={"+"}>
                +
              </MenuItem>
            ) : null}
          </Select>
          {props.helperText && <FormHelperText>{props.helperText}</FormHelperText>}
        </FormControl>

        <TextFieldDialog
          title={"VAT"}
          key={value === "+" ? "1" : "0"}
          open={value === "+"}
          value={""}
          onSubmit={(newValue) => {
            props.onUnknown(newValue, setBeginValue);
          }}
        />
      </ThemeProvider>
    );
  };

  return props.authorizationField ? (
    <AuthorizationWrapper
      permission={props.authorizationField}
      child={(write) => {
        return getField(write);
      }}
    />
  ) : (
    getField(true)
  );
}

EditSelect.propTypes = {
  authorizationField: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func,
  optionValues: PropTypes.array.isRequired,
  optionViewValues: PropTypes.array.isRequired,
  allowUnknown: PropTypes.bool,
};

export default EditSelect;
